import { computed } from 'vue'

/**
 * Core logic composable for MsCheckbox
 * Xử lý trạng thái và logic chính của checkbox
 */
export function useCheckbox(props) {
  // Computed: Kiểm tra checkbox có được check không
  // Ưu tiên modelValue, fallback về checked prop
  const isChecked = computed(() => Boolean(props.modelValue || props.checked))

  // Computed: Kiểm tra checkbox có disabled không
  const isDisabled = computed(() => props.disabled)

  // Computed: Kiểm tra có readonly không
  const isReadOnly = computed(() => props.readOnly)

  // Computed: Kiểm tra có hiển thị label không
  const shouldShowLabel = computed(() => props.label && props.isShowLabel)

  // Computed: Kiểm tra có label text không
  const hasLabel = computed(() => Boolean(props.label))

  return {
    isChecked,
    isDisabled,
    isReadOnly,
    shouldShowLabel,
    hasLabel,
  }
}
